export default __webpack_public_path__ + "static/media/passCount.7a3cc332.svg";